import React from 'react';
import './index.scss';

export default () => {
  return (
    <div id="privacy">
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '@import url(https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUXza5VhXqVC6o75Eld_V98);.lst-kix_list_14-1>li:before{content:"o  "}.lst-kix_list_14-3>li:before{content:"\\0025cf   "}ul.lst-kix_list_1-0{list-style-type:none}.lst-kix_list_14-0>li:before{content:"\\0025cf   "}.lst-kix_list_14-4>li:before{content:"o  "}.lst-kix_list_14-5>li:before{content:"\\0025aa   "}.lst-kix_list_14-7>li:before{content:"o  "}.lst-kix_list_14-6>li:before{content:"\\0025cf   "}ul.lst-kix_list_9-3{list-style-type:none}ul.lst-kix_list_9-4{list-style-type:none}ul.lst-kix_list_9-1{list-style-type:none}ul.lst-kix_list_9-2{list-style-type:none}ul.lst-kix_list_9-7{list-style-type:none}ul.lst-kix_list_9-8{list-style-type:none}ul.lst-kix_list_9-5{list-style-type:none}ul.lst-kix_list_9-6{list-style-type:none}ul.lst-kix_list_1-3{list-style-type:none}ul.lst-kix_list_1-4{list-style-type:none}ul.lst-kix_list_1-1{list-style-type:none}ul.lst-kix_list_1-2{list-style-type:none}ul.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_9-0{list-style-type:none}ul.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_1-5{list-style-type:none}.lst-kix_list_14-2>li:before{content:"\\0025aa   "}ul.lst-kix_list_1-6{list-style-type:none}.lst-kix_list_14-8>li:before{content:"\\0025aa   "}.lst-kix_list_5-0>li:before{content:"\\0025cf   "}.lst-kix_list_5-3>li:before{content:"\\0025aa   "}.lst-kix_list_5-2>li:before{content:"\\0025aa   "}.lst-kix_list_5-1>li:before{content:"o  "}.lst-kix_list_5-7>li:before{content:"\\0025aa   "}ul.lst-kix_list_8-4{list-style-type:none}ul.lst-kix_list_8-5{list-style-type:none}.lst-kix_list_5-6>li:before{content:"\\0025aa   "}.lst-kix_list_5-8>li:before{content:"\\0025aa   "}ul.lst-kix_list_8-2{list-style-type:none}ul.lst-kix_list_8-3{list-style-type:none}ul.lst-kix_list_8-8{list-style-type:none}ul.lst-kix_list_8-6{list-style-type:none}ul.lst-kix_list_8-7{list-style-type:none}.lst-kix_list_5-4>li:before{content:"\\0025aa   "}.lst-kix_list_5-5>li:before{content:"\\0025aa   "}ul.lst-kix_list_8-0{list-style-type:none}ul.lst-kix_list_8-1{list-style-type:none}.lst-kix_list_6-1>li:before{content:"o  "}.lst-kix_list_6-3>li:before{content:"\\0025aa   "}.lst-kix_list_6-0>li:before{content:"\\0025cf   "}.lst-kix_list_6-4>li:before{content:"\\0025aa   "}.lst-kix_list_6-2>li:before{content:"\\0025aa   "}.lst-kix_list_6-8>li:before{content:"\\0025aa   "}.lst-kix_list_6-5>li:before{content:"\\0025aa   "}.lst-kix_list_6-7>li:before{content:"\\0025aa   "}.lst-kix_list_6-6>li:before{content:"\\0025aa   "}.lst-kix_list_2-7>li:before{content:"\\0025aa   "}.lst-kix_list_7-4>li:before{content:"\\0025aa   "}.lst-kix_list_7-6>li:before{content:"\\0025aa   "}.lst-kix_list_2-5>li:before{content:"\\0025aa   "}.lst-kix_list_7-2>li:before{content:"\\0025aa   "}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}.lst-kix_list_10-1>li:before{content:"o  "}.lst-kix_list_13-7>li:before{content:"o  "}ul.lst-kix_list_3-1{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_7-8>li:before{content:"\\0025aa   "}ul.lst-kix_list_3-0{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}.lst-kix_list_10-7>li:before{content:"\\0025aa   "}.lst-kix_list_15-5>li:before{content:"\\0025aa   "}.lst-kix_list_10-5>li:before{content:"\\0025aa   "}.lst-kix_list_10-3>li:before{content:"\\0025aa   "}ul.lst-kix_list_11-7{list-style-type:none}ul.lst-kix_list_11-6{list-style-type:none}.lst-kix_list_4-1>li:before{content:"o  "}ul.lst-kix_list_11-5{list-style-type:none}ul.lst-kix_list_11-4{list-style-type:none}ul.lst-kix_list_11-3{list-style-type:none}.lst-kix_list_15-7>li:before{content:"o  "}ul.lst-kix_list_11-2{list-style-type:none}ul.lst-kix_list_11-1{list-style-type:none}ul.lst-kix_list_11-0{list-style-type:none}.lst-kix_list_9-2>li:before{content:"\\0025aa   "}.lst-kix_list_4-3>li:before{content:"\\0025aa   "}.lst-kix_list_4-5>li:before{content:"\\0025aa   "}ul.lst-kix_list_11-8{list-style-type:none}.lst-kix_list_15-1>li:before{content:"o  "}.lst-kix_list_9-0>li:before{content:"\\0025cf   "}.lst-kix_list_15-3>li:before{content:"\\0025cf   "}.lst-kix_list_9-6>li:before{content:"\\0025aa   "}.lst-kix_list_9-4>li:before{content:"\\0025aa   "}.lst-kix_list_11-3>li:before{content:"\\0025aa   "}ul.lst-kix_list_2-8{list-style-type:none}.lst-kix_list_12-3>li:before{content:"\\0025aa   "}.lst-kix_list_11-5>li:before{content:"\\0025aa   "}.lst-kix_list_12-1>li:before{content:"o  "}ul.lst-kix_list_2-2{list-style-type:none}ul.lst-kix_list_2-3{list-style-type:none}ul.lst-kix_list_2-0{list-style-type:none}ul.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_9-8>li:before{content:"\\0025aa   "}ul.lst-kix_list_2-6{list-style-type:none}.lst-kix_list_1-1>li:before{content:"o  "}ul.lst-kix_list_2-7{list-style-type:none}.lst-kix_list_11-7>li:before{content:"\\0025aa   "}ul.lst-kix_list_2-4{list-style-type:none}ul.lst-kix_list_2-5{list-style-type:none}ul.lst-kix_list_10-0{list-style-type:none}.lst-kix_list_1-3>li:before{content:"\\0025aa   "}.lst-kix_list_13-3>li:before{content:"\\0025cf   "}ul.lst-kix_list_10-8{list-style-type:none}ul.lst-kix_list_10-7{list-style-type:none}.lst-kix_list_1-7>li:before{content:"\\0025aa   "}ul.lst-kix_list_10-6{list-style-type:none}ul.lst-kix_list_10-5{list-style-type:none}ul.lst-kix_list_10-4{list-style-type:none}ul.lst-kix_list_10-3{list-style-type:none}.lst-kix_list_1-5>li:before{content:"\\0025aa   "}ul.lst-kix_list_10-2{list-style-type:none}ul.lst-kix_list_10-1{list-style-type:none}.lst-kix_list_13-5>li:before{content:"\\0025aa   "}.lst-kix_list_12-5>li:before{content:"\\0025aa   "}.lst-kix_list_12-7>li:before{content:"\\0025aa   "}.lst-kix_list_2-1>li:before{content:"o  "}.lst-kix_list_2-3>li:before{content:"\\0025aa   "}.lst-kix_list_13-1>li:before{content:"o  "}.lst-kix_list_3-0>li:before{content:"\\0025cf   "}ul.lst-kix_list_5-7{list-style-type:none}ul.lst-kix_list_5-8{list-style-type:none}.lst-kix_list_3-1>li:before{content:"o  "}.lst-kix_list_3-2>li:before{content:"\\0025aa   "}ul.lst-kix_list_5-5{list-style-type:none}ul.lst-kix_list_5-6{list-style-type:none}.lst-kix_list_8-1>li:before{content:"o  "}.lst-kix_list_8-2>li:before{content:"\\0025aa   "}.lst-kix_list_3-5>li:before{content:"\\0025aa   "}ul.lst-kix_list_5-0{list-style-type:none}.lst-kix_list_3-4>li:before{content:"\\0025aa   "}ul.lst-kix_list_5-3{list-style-type:none}.lst-kix_list_3-3>li:before{content:"\\0025aa   "}ul.lst-kix_list_5-4{list-style-type:none}ul.lst-kix_list_5-1{list-style-type:none}.lst-kix_list_8-0>li:before{content:"\\0025cf   "}ul.lst-kix_list_5-2{list-style-type:none}.lst-kix_list_8-7>li:before{content:"\\0025aa   "}.lst-kix_list_3-8>li:before{content:"\\0025aa   "}.lst-kix_list_8-5>li:before{content:"\\0025aa   "}.lst-kix_list_8-6>li:before{content:"\\0025aa   "}.lst-kix_list_8-3>li:before{content:"\\0025aa   "}ul.lst-kix_list_13-5{list-style-type:none}ul.lst-kix_list_13-4{list-style-type:none}ul.lst-kix_list_13-3{list-style-type:none}.lst-kix_list_3-6>li:before{content:"\\0025aa   "}ul.lst-kix_list_13-2{list-style-type:none}ul.lst-kix_list_13-1{list-style-type:none}.lst-kix_list_3-7>li:before{content:"\\0025aa   "}ul.lst-kix_list_13-0{list-style-type:none}.lst-kix_list_8-4>li:before{content:"\\0025aa   "}.lst-kix_list_11-2>li:before{content:"\\0025aa   "}ul.lst-kix_list_13-8{list-style-type:none}.lst-kix_list_11-1>li:before{content:"o  "}ul.lst-kix_list_13-7{list-style-type:none}ul.lst-kix_list_13-6{list-style-type:none}.lst-kix_list_11-0>li:before{content:"\\0025cf   "}.lst-kix_list_8-8>li:before{content:"\\0025aa   "}.lst-kix_list_4-8>li:before{content:"\\0025aa   "}.lst-kix_list_4-7>li:before{content:"\\0025aa   "}ul.lst-kix_list_4-8{list-style-type:none}ul.lst-kix_list_4-6{list-style-type:none}ul.lst-kix_list_4-7{list-style-type:none}ul.lst-kix_list_4-0{list-style-type:none}ul.lst-kix_list_4-1{list-style-type:none}ul.lst-kix_list_4-4{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}ul.lst-kix_list_12-6{list-style-type:none}ul.lst-kix_list_12-5{list-style-type:none}ul.lst-kix_list_12-4{list-style-type:none}ul.lst-kix_list_12-3{list-style-type:none}ul.lst-kix_list_12-2{list-style-type:none}ul.lst-kix_list_12-1{list-style-type:none}ul.lst-kix_list_12-0{list-style-type:none}ul.lst-kix_list_12-8{list-style-type:none}ul.lst-kix_list_12-7{list-style-type:none}.lst-kix_list_7-0>li:before{content:"\\0025cf   "}.lst-kix_list_2-6>li:before{content:"\\0025aa   "}.lst-kix_list_2-4>li:before{content:"\\0025aa   "}.lst-kix_list_2-8>li:before{content:"\\0025aa   "}.lst-kix_list_7-1>li:before{content:"o  "}.lst-kix_list_7-5>li:before{content:"\\0025aa   "}.lst-kix_list_7-3>li:before{content:"\\0025aa   "}ul.lst-kix_list_7-5{list-style-type:none}.lst-kix_list_10-0>li:before{content:"\\0025cf   "}ul.lst-kix_list_7-6{list-style-type:none}ul.lst-kix_list_7-3{list-style-type:none}ul.lst-kix_list_7-4{list-style-type:none}.lst-kix_list_13-6>li:before{content:"\\0025cf   "}.lst-kix_list_13-8>li:before{content:"\\0025aa   "}ul.lst-kix_list_7-7{list-style-type:none}ul.lst-kix_list_7-8{list-style-type:none}ul.lst-kix_list_7-1{list-style-type:none}ul.lst-kix_list_7-2{list-style-type:none}ul.lst-kix_list_7-0{list-style-type:none}.lst-kix_list_7-7>li:before{content:"\\0025aa   "}.lst-kix_list_15-4>li:before{content:"o  "}.lst-kix_list_15-6>li:before{content:"\\0025cf   "}.lst-kix_list_10-4>li:before{content:"\\0025aa   "}.lst-kix_list_10-8>li:before{content:"\\0025aa   "}.lst-kix_list_4-0>li:before{content:"\\0025cf   "}ul.lst-kix_list_15-3{list-style-type:none}ul.lst-kix_list_15-2{list-style-type:none}.lst-kix_list_15-0>li:before{content:"-  "}ul.lst-kix_list_15-1{list-style-type:none}.lst-kix_list_15-8>li:before{content:"\\0025aa   "}ul.lst-kix_list_15-0{list-style-type:none}.lst-kix_list_10-2>li:before{content:"\\0025aa   "}.lst-kix_list_4-4>li:before{content:"\\0025aa   "}ul.lst-kix_list_15-8{list-style-type:none}.lst-kix_list_4-2>li:before{content:"\\0025aa   "}.lst-kix_list_4-6>li:before{content:"\\0025aa   "}ul.lst-kix_list_15-7{list-style-type:none}ul.lst-kix_list_15-6{list-style-type:none}.lst-kix_list_9-3>li:before{content:"\\0025aa   "}ul.lst-kix_list_15-5{list-style-type:none}ul.lst-kix_list_15-4{list-style-type:none}.lst-kix_list_15-2>li:before{content:"\\0025aa   "}.lst-kix_list_10-6>li:before{content:"\\0025aa   "}.lst-kix_list_9-1>li:before{content:"o  "}.lst-kix_list_9-7>li:before{content:"\\0025aa   "}.lst-kix_list_11-4>li:before{content:"\\0025aa   "}.lst-kix_list_12-4>li:before{content:"\\0025aa   "}.lst-kix_list_9-5>li:before{content:"\\0025aa   "}ul.lst-kix_list_6-6{list-style-type:none}ul.lst-kix_list_6-7{list-style-type:none}ul.lst-kix_list_6-4{list-style-type:none}ul.lst-kix_list_6-5{list-style-type:none}ul.lst-kix_list_6-8{list-style-type:none}.lst-kix_list_12-2>li:before{content:"\\0025aa   "}.lst-kix_list_11-6>li:before{content:"\\0025aa   "}.lst-kix_list_1-0>li:before{content:"\\0025cf   "}ul.lst-kix_list_6-2{list-style-type:none}.lst-kix_list_11-8>li:before{content:"\\0025aa   "}ul.lst-kix_list_6-3{list-style-type:none}.lst-kix_list_1-2>li:before{content:"\\0025aa   "}ul.lst-kix_list_6-0{list-style-type:none}.lst-kix_list_12-0>li:before{content:"\\0025cf   "}ul.lst-kix_list_6-1{list-style-type:none}.lst-kix_list_1-4>li:before{content:"\\0025aa   "}.lst-kix_list_13-0>li:before{content:"\\0025cf   "}ul.lst-kix_list_14-4{list-style-type:none}ul.lst-kix_list_14-3{list-style-type:none}ul.lst-kix_list_14-2{list-style-type:none}.lst-kix_list_13-4>li:before{content:"o  "}ul.lst-kix_list_14-1{list-style-type:none}ul.lst-kix_list_14-0{list-style-type:none}.lst-kix_list_1-6>li:before{content:"\\0025aa   "}ul.lst-kix_list_14-8{list-style-type:none}ul.lst-kix_list_14-7{list-style-type:none}.lst-kix_list_2-0>li:before{content:"\\0025cf   "}.lst-kix_list_12-6>li:before{content:"\\0025aa   "}ul.lst-kix_list_14-6{list-style-type:none}ul.lst-kix_list_14-5{list-style-type:none}.lst-kix_list_1-8>li:before{content:"\\0025aa   "}.lst-kix_list_2-2>li:before{content:"\\0025aa   "}.lst-kix_list_13-2>li:before{content:"\\0025aa   "}.lst-kix_list_12-8>li:before{content:"\\0025aa   "}ol{margin:0;padding:0}table td,table th{padding:0}.c2{margin-left:72pt;padding-top:0pt;padding-left:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c6{margin-left:36pt;padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left;height:11pt}.c5{margin-left:36pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c16{margin-left:18pt;padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c9{padding-top:0pt;padding-bottom:6pt;line-height:1.0;orphans:2;widows:2;text-align:center;height:11pt}.c1{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Georgia";font-style:normal}.c18{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:right}.c21{padding-top:6pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:right}.c4{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c23{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:center}.c19{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c10{-webkit-text-decoration-skip:none;color:#0000ff;font-weight:400;text-decoration:underline;text-decoration-skip-ink:none;font-family:"Georgia"}.c14{color:#000000;text-decoration:none;vertical-align:baseline;font-size:11pt;font-style:normal}.c22{color:#000000;text-decoration:none;vertical-align:baseline;font-size:8pt;font-style:normal}.c17{background-color:#ffffff;max-width:451.3pt;padding:72pt 72pt 72pt 72pt}.c7{font-family:"Georgia";font-weight:400}.c8{margin-left:36pt;padding-left:0pt}.c12{font-weight:400;font-family:"Georgia"}.c20{font-weight:400;font-family:"Calibri"}.c3{font-weight:700;font-family:"Georgia"}.c15{color:inherit;text-decoration:inherit}.c0{padding:0;margin:0}.c13{margin-left:36pt}.c11{height:11pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:"Georgia";line-height:1.1500000000000001;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Calibri"}p{margin:0;color:#000000;font-size:11pt;font-family:"Calibri"}h1{padding-top:0pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:10pt;font-family:"Times New Roman";line-height:1.0;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:14pt;color:#000000;font-weight:700;font-size:14pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:12pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}'
        }}
      />

      <div className="margiano">
        <p className="c18">
          <span className="c1"></span>
        </p>
      </div>
      <p className="c23 pri-center" id="h.gjdgxs">
        <span className="c14 c3 main pri">OUR PRIVACY POLICY</span>
      </p>
      <p className="c4">
        <span className="c7">Effective date</span>
        <span className="c1">:</span>
      </p>
      <p className="c4">
        <span className="c1">
          Hybrid respects your privacy and recognises you have the right to
          control your personal data. Hybrid is committed to protecting your
          privacy and complying with the provisions of Personal Data (Privacy)
          Ordinance (Cap. 486), the data privacy law in Hong Kong, and other
          applicable data protection laws. You providing your personal data to
          us is an act of trust and we take it very seriously. Unless you
          consent, Hybrid will only collect, use, store, disseminate and retain
          your personal data as set out in this Privacy Policy.
        </span>
      </p>
      <p className="c4">
        <span className="c1">
          This Privacy Policy explains how your personal data will be treated
          either upon becoming a member of Hybrid, registering for free
          consultation, when you browse the Website or download and register the
          App. If you are under the age of 18, you must ask your parent or
          guardian before providing any personal data to Hybrid. Our Website and
          App are not designed for use by anyone under 18. &nbsp;{' '}
        </span>
      </p>
      <p className="c4">
        <span className="c12">Please feel free to send an email to </span>
        <span className="c10">
          <a className="c15" href="mailto:privacy@hybridmmafit.com">
            privacy@hybridmmafit.com
          </a>
        </span>
        <span className="c1">&nbsp;if you wish to:</span>
      </p>
      <ul className="c0 lst-kix_list_1-0 start">
        <li className="c4 c8">
          <span className="c1">
            receive assistance on the meaning of the contents of this Privacy
            Policy
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            request access to, deletion of or correction of personal data or for
            general information regarding our privacy policy
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            know what kind of personal data that we hold
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">make any general questions or complaints</span>
        </li>
      </ul>
      <p className="c4">
        <span className="c1">
          To protect your privacy, the email should be marked ‘PRIVATE &amp;
          CONFIDENTIAL’.
        </span>
      </p>
      <p className="c4 c11">
        <span className="c3 c14" />
      </p>
      <p className="c4">
        <span className="c3">Collecting Your Personal Data</span>
      </p>
      <p className="c4">
        <span className="c1">
          Hybrid collects personal data to in connection with providing its
          products and services, offering information which may be of interest
          to you and operating and improving its products and services.
        </span>
      </p>
      <p className="c4">
        <span className="c1">
          When you become a member or register for one of our products or
          services (a Student), we will require you to provide the following
          mandatory categories of personal data:
        </span>
      </p>
      <ul className="c0 lst-kix_list_2-0 start">
        <li className="c4 c8">
          <span className="c1">
            name (full names if your name is in more than one language), address
            (residential/office and email), phone number (mobile and
            residential/office), emergency contact information (name and phone
            number), whether you are from the EU, gender, age group, marital
            status, identity card or passport number (but we will not collect
            copy of your identity card or passport), profile photo, company name
            and address
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            credit card details, payment details including type of payment
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            your type of membership; your class and goal
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">year of becoming Hybrid’s member</span>
        </li>
        <li className="c4 c8">
          <span className="c1">how you heard of Hybrid</span>
        </li>
      </ul>
      <p className="c4">
        <span className="c12">
          We may also collect the following types of personal data, if you are a
          Student and choose to provide it to us:
        </span>
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c5">
          <span className="c1">
            Food and beverage tracking: details of your food and water intake,
            including photos or images of your food or beverage, description of
            your food or beverage, time of your food or beverage intake, the
            nutrition value and calories of your food and beverage and
            description of your food or beverage.
          </span>
        </li>
      </ul>
      <p className="c6">
        <span className="c1" />
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c5">
          <span className="c1">
            Health data: your date of birth, gender, weight, height, BMI, heart
            rate measurements, blood pressure measurements, other health data
            from Apple Health or Google Fit such as your step count and heart
            rate;
          </span>
        </li>
      </ul>
      <p className="c6">
        <span className="c1" />
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c5">
          <span className="c1">
            Medical history: details of your medical history such as your heart
            conditions, chest pain or other conditions which might affect your
            when performing physical activities;
          </span>
        </li>
      </ul>
      <p className="c6">
        <span className="c1" />
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c5">
          <span className="c1">Demographic information: Gender</span>
        </li>
      </ul>
      <p className="c6">
        <span className="c1" />
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c5">
          <span className="c1">
            Personal Training: information about your fitness performance and
            details of the types of exercises you have done including photos
            and/or videos of your physical exercise performance, your body
            measurements, your responses to our evaluation of your fitness,
            health and nutrition goals which may be conducted on the App or in
            person by the personal trainer;
          </span>
        </li>
      </ul>
      <p className="c6">
        <span className="c1" />
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c5">
          <span className="c1">
            Progress management: details on your progress which can include
            photos of you which you upload onto the App, your weight, body fat
            percentage, hunger rating, craving rating and digestion rating; and
          </span>
        </li>
      </ul>
      <p className="c6">
        <span className="c1" />
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c4 c8">
          <span className="c1">any other information you provide to us.</span>
        </li>
      </ul>
      <p className="c19">
        <span className="c1">
          When you visit our Website or use any of our products and services as
          a Student or visit our Website (regardless of whether you are a
          Student), the following categories of personal information may
          automatically be collected from you:
        </span>
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c4 c8">
          <span className="c1">
            Information about your interaction with the Website, the App, our
            products and services, including device and connection information
            (including geolocation information), traffic to and from the sites,
            IP address and standard web log information
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            Details of your conversation with the personal trainers on the App
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            Information related to your adherence to your Student fitness plan
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            Your attendance record and purchase history.{' '}
          </span>
        </li>
      </ul>
      <p className="c4">
        <span className="c1">
          If you are a personal trainer using the App, we may collect the
          following personal data about you:
        </span>
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c5">
          <span className="c1">
            Account details: your name, telephone number, e-mail address,
            password, profile photos;
          </span>
        </li>
      </ul>
      <p className="c11 c16">
        <span className="c1" />
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c5">
          <span className="c1">
            Credentials: the number of clients you have, certifications, areas
            of focus, active status;
          </span>
        </li>
      </ul>
      <p className="c6">
        <span className="c1" />
      </p>
      <ul className="c0 lst-kix_list_2-0">
        <li className="c4 c8">
          <span className="c1">
            Client: details on your interaction with your clients on the App
            including your ratings of your clients, details of the workout and
            nutrition plan you have created for your clients, your notes on the
            App and details of your conversation on the App with your clients.
          </span>
        </li>
      </ul>
      <p className="c4">
        <span className="c1">
          We will verify some of your data by cross checking with your identity
          card or passport when you submit your application for free trial or
          membership of Hybrid.
        </span>
      </p>
      <p className="c4">
        <span className="c1">
          Your name, e-mail address and age are “mandatory” personal data which
          are necessary for the purposes of:
        </span>
      </p>
      <ul className="c0 lst-kix_list_3-0 start">
        <li className="c4 c8">
          <span className="c1">
            application, operation, administration, continuation, alteration,
            enhancement and termination of the our products and services.
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            ensuring your safety and welfare should emergency occurred when you
            are at the Club or receiving our services.
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            choosing, offering and arranging the appropriate products/services
            (provided by Hybrid or third-party providers) specific to your age
            or physical capacity or other requirements specified by you.
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            for you to register with the App or the Website (as the case may
            be).
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            supplying you with updates, notices and other communications our
            products and services.
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            processing and requesting billing and payment, determining amounts
            outstanding, and if necessary, collection of outstanding payments.
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            responding to your request, enquiry and complaint by telephone,
            email, letter or other form of communication by the same means.
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            complying with obligations, requirements, recommendations and
            instructions to make disclosure to any regulatory or other
            authorities (including industry and self-regulatory bodies) in Hong
            Kong under the requirements of any laws binding on us or in legal
            proceedings.
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            allowing us to select for you the appropriate products and services.
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            if you are using the App as a customer/App user:
          </span>
        </li>
      </ul>
      <ul className="c0 lst-kix_list_3-1 start">
        <li className="c2">
          <span className="c1">
            creating custom fitness and nutrition plans to help you achieve your
            personal goals;
          </span>
        </li>
        <li className="c2">
          <span className="c1">
            to provide you with the tools necessary to track your food and
            drinks intake and your fitness and health progression;
          </span>
        </li>
        <li className="c2">
          <span className="c1">
            to communicate with you on matters pertaining to your fitness,
            nutritional and health goals including any queries or complaints you
            &nbsp;may have; and
          </span>
        </li>
        <li className="c2">
          <span className="c1">
            [to communicate with you regarding third party supplier products and
            services which you may be interested in].
          </span>
        </li>
      </ul>
      <ul className="c0 lst-kix_list_3-0">
        <li className="c4 c8">
          <span className="c1">
            other purposes directly relating to any of the above purposes.
          </span>
        </li>
      </ul>
      <p className="c4">
        <span className="c1">
          We use personal data that we collect automatically from Students and
          Website visitors for the purposes of providing and improving our
          products and services, for advertising purposes, for billing purposes,
          to comply with law.
        </span>
      </p>
      <p className="c4">
        <span className="c1">
          If you do not provide us with the personal data marked as “mandatory”,
          we may not be able to provide our services above to you.{' '}
        </span>
      </p>
      <p className="c4 c11">
        <span className="c1" />
      </p>
      <p className="c4">
        <span className="c3">Using Your Contact Information</span>
      </p>
      <p className="c4">
        <span className="c1">
          Hybrid intends to use your contact information (email address and
          mobile phone number), age group, health and fitness progress data and
          name in direct marketing of our products (food and beverages, apparel,
          equipment, accessories, tools and equipment) and services (mixed
          martial arts, sports, physical disciplines training and consultation),
          both online and offline, in relation to health, fitness, lifestyle,
          entertainment, leisure and sports, offering discount, special offer or
          other forms of benefit to and in relation to our products and services
          of or relating to, health together with promotion of the same such as
          newsletters, informational materials, updates and events, rewards,
          promotions, events and benefits related to or offered by Hybrid.
        </span>
      </p>
      <p className="c4">
        <span className="c1">
          Hybrid will not use your contact information in direct marketing or
          joint promotion unless we have your consent. If you would like to
          receive direct marketing materials from Hybrid, please sign below.
        </span>
      </p>
      <p className="c4 c13">
        <span className="c1">
          I understand Hybrid intends to use my personal data in direct
          marketing of Hybrid’s products and services. In that regard I confirm
          my agreement to Hybrid using:-
        </span>
      </p>
      <p className="c4 c13">
        <span className="c1">a)&nbsp;my following personal data:</span>
      </p>
      <ul className="c0 lst-kix_list_4-0 start">
        <li className="c2">
          <span className="c1">
            contact information (email address and mobile phone number)
          </span>
        </li>
        <li className="c2">
          <span className="c1">health and fitness progress data</span>
        </li>
        <li className="c2">
          <span className="c1">age group</span>
        </li>
        <li className="c2">
          <span className="c1">name</span>
        </li>
      </ul>
      <p className="c4 c13">
        <span className="c1">
          b)&nbsp;by the following means of communication:
        </span>
      </p>
      <ul className="c0 lst-kix_list_5-0 start">
        <li className="c2">
          <span className="c1">email</span>
        </li>
        <li className="c2">
          <span className="c1">mobile phone</span>
        </li>
        <li className="c2">
          <span className="c1">internet</span>
        </li>
      </ul>
      <p className="c4">
        <span className="c1">
          If it later becomes necessary to take legal action to recover money
          you owe us or for any other reason, you expressly agree that the
          contact information collected from you can be relied upon in
          identifying you for that purpose.
        </span>
      </p>
      <p className="c4 c11">
        <span className="c1" />
      </p>
      <p className="c4">
        <span className="c3">Storing Your Personal Data</span>
      </p>
      <p className="c4">
        <span className="c1">
          Hybrid strives to provide the utmost data security to the personal
          data it collects. .
        </span>
      </p>
      <p className="c4 c11">
        <span className="c14 c3" />
      </p>
      <p className="c4">
        <span className="c3">Disseminating Your Personal Data</span>
      </p>
      <p className="c4">
        <span className="c1">
          Hybrid may transfer/assign your personal data to the following:
        </span>
      </p>
      <ul className="c0 lst-kix_list_6-0 start">
        <li className="c4 c8">
          <span className="c1">
            any person, firm or company to which Hybrid sells any part of its
            business;
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            any agent, adviser, auditor, third-party providers or service
            provider who provides services to Hybrid (including administrative,
            telecommunications, computer, information technology, payment,
            insurance, data processing and/or other services) in connection with
            our business insofar as required to enable us to provide, or assist
            us in providing, the products and services to you; and
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            any person to whom Hybrid is under an obligation to make disclosure
            under the requirements of any law binding on Hybrid or for the
            purposes of any guidelines or codes of practice issued by regulatory
            or other authorities with which Hybrid is expected to comply.
          </span>
        </li>
      </ul>
      <p className="c4">
        <span className="c1">
          Hybrid may sub-contract our obligations to third-party providers
          without notice but if we do, we are still responsible for ensuring
          those obligations are met.
        </span>
      </p>
      <p className="c4">
        <span className="c1">
          If you are using the App, your personal data may also be (i) shared
          with the personal trainer(s) you are working with using the Hybrid
          App; (ii) transferred to a place outside of Hong Kong where the
          relevant servers hosting and supporting the App and the services
          provided through the App are located, including countries such as
          United States of America, Japan, Singapore and Australia. In any case,
          we will ensure that your personal data remains subject to a standard
          of protection comparable to the requirements under the Personal Data
          (Privacy) Ordinance (Cap. 486).{' '}
        </span>
      </p>
      <p className="c4">
        <span className="c3">Retaining Your Personal Data</span>
      </p>
      <p className="c4">
        <span className="c1">
          We will retain your personal data for as long as necessary to fulfil
          the purpose for which the data was collected. We may also retain
          archived personal data for statistical purposes. Personal data which
          is no longer required will be erased.
        </span>
      </p>
      <p className="c4 c11">
        <span className="c14 c3" />
      </p>
      <p className="c4">
        <span className="c3">Hong Kong: Data Access and Correction</span>
      </p>
      <p className="c4">
        <span className="c12">
          You can at any time request access to or correct your personal data
          collected by us or to delete your name or your personal data from any
          marketing activities. Just send your request to&nbsp;
        </span>
        <span className="c10">
          <a className="c15" href="mailto:privacy@hybridmmafit.com">
            privacy@hybridmmafit.com
          </a>
        </span>
        <span className="c1">
          . To protect your privacy, the covering email should be marked
          ‘PRIVATE &amp; CONFIDENTIAL’. Hybrid may ask for certain details for
          identification purposes. We are required to respond to your request
          within 40 days but we may charge you a reasonable fee for doing so. We
          will not retain your personal data when you request to cancel your
          membership of Hybrid and we will erase your personal data as soon as
          practicable after we are no longer obliged to retain such data by law.
        </span>
      </p>
      <p className="c4">
        <span className="c14 c3">
          California residents: Your Privacy Rights
        </span>
      </p>
      <p className="c4">
        <span className="c1">
          If you reside in California, you are entitled to request:
        </span>
      </p>
      <ul className="c0 lst-kix_list_14-0 start">
        <li className="c5">
          <span className="c1">
            The categories and/or specific pieces of personal data Hybrid has
            collected from or about you during the preceding 12 months, and
          </span>
        </li>
        <li className="c4 c8">
          <span className="c1">
            Deletion of your personal data, which Hybrid will be required to
            honor under certain circumstances.
          </span>
        </li>
      </ul>
      <p className="c4">
        <span className="c12">
          Hybrid will not discriminate against you if you make such a request,
          but in some cases we will not be able to provide our products or
          services to you if we delete your personal data.&nbsp; You may send
          your request to{' '}
        </span>
        <span className="c10">
          <a className="c15" href="mailto:privacy@hybridmmafit.com">
            privacy@hybridmmafit.com
          </a>
        </span>
        <span className="c12">&nbsp;or [</span>
        <span className="c7">U.S. mailing address</span>
        <span className="c1">
          ]. &nbsp;Note that Hybrid’s Website and App are not configured to
          respond to Do Not Track Requests.
        </span>
      </p>
      <p className="c4 c11">
        <span className="c14 c3" />
      </p>
      <p className="c4">
        <span className="c3">Cookies</span>
      </p>
      <p className="c4">
        <span className="c1">
          The Website uses Cookies and personal data may be collected through
          the use of Cookies which are small data files sent from a website and
          stored on the hard drive of your computer or other devices by your web
          browser while you browse the Website. Most web browsers automatically
          accept Cookies but you can edit your browser options to block them but
          you may not be able to access certain areas of the Website.
        </span>
      </p>
      <p className="c4 c11">
        <span className="c14 c3" />
      </p>
      <p className="c4">
        <span className="c3">Hyperlinks</span>
      </p>
      <p className="c4">
        <span className="c1">
          If you click on any advertisements or hyperlinks appearing on the
          Website or the App linking to another website, you will leave the
          Website or the App for another location and we shall not be
          responsible for the privacy and security practices or the content of
          such website.
        </span>
      </p>
      <p className="c4">
        <span className="c1">&nbsp;</span>
      </p>
      <p className="c4">
        <span className="c3">Update</span>
      </p>
      <p className="c4">
        <span className="c1">
          We may change the terms of this Privacy Policy from time to time.
          Please check for the latest terms at the Website before you use the
          App or browse the Website and your continued use/browsing shall be
          treated as your acceptance of such changes.
        </span>
      </p>
      <p className="c4">
        <span className="c1">&nbsp;</span>
      </p>
      <p className="c4">
        <span className="c3">Applicable Law</span>
      </p>
      <p className="c4">
        <span className="c1">
          This Privacy Policy shall be governed by and construed in accordance
          with the laws of Hong Kong Special Administrative Region of the
          People’s Republic of China.
        </span>
      </p>
      <p className="c4">
        <span className="c1">&nbsp;</span>
      </p>
      <p className="c4">
        <span className="c3">English Version and Chinese Translation</span>
        <span className="c1">&nbsp;</span>
      </p>
      <p className="c4">
        <span className="c1">
          This Privacy Policy is written in English language and may have
          translation in other languages. If there is any discrepancy or
          conflict between the English version and any of its translation(s),
          the English version prevails.
        </span>
      </p>
      <p className="c4">
        <span className="c1">&nbsp;</span>
      </p>
      <p className="c4">
        <span className="c3">General Data Protection Regulation (GDPR)</span>
        <span className="c1">&nbsp;</span>
      </p>
      <p className="c4">
        <span className="c12">
          Although GDRP is an EU regulation, it applies to all businesses that
          handle data belonging to a business or individual within the EU, even
          if the business operates outside the EU. If you are from an EU member
          state, GDPR applies to us and we need to take measures to comply with
          GDPR. Please confirm if you are a citizen from a EU member state
          below; check here :&nbsp;
        </span>
        <span className="c10">
          <a
            className="c15"
            href="https://www.google.com/url?q=https://europa.eu/european-union/about-eu/countries_en&sa=D&ust=1600164223649000&usg=AOvVaw2W2w8X2ASjcQ0-JV6zw8CY"
          >
            https://europa.eu/european-union/about-eu/countries_en
          </a>
        </span>
      </p>
      <div>
        <p className="c9">
          <span className="c14 c20" />
        </p>
        <p className="c21"></p>
      </div>
    </div>
  );
};
